import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_j4haqxftb2: FaireBrandEntity = {
  token: "b_j4haqxftb2",
  type: "brand",
  name: "Magpie",
  avatarUrl:
    "https://cdn.faire.com/fastly/ac0d624ae35dbd84272cc0946097760d58734a561d75ac0eba4981e50af13b57.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1f49e2d452ba7a433a0bc593115713bedce47d315d2a54ddd9b9e72803bd4d6e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/ac0d624ae35dbd84272cc0946097760d58734a561d75ac0eba4981e50af13b57.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1f49e2d452ba7a433a0bc593115713bedce47d315d2a54ddd9b9e72803bd4d6e.png",
  location: "Prescott , AZ, USA",
  minimumOrderDollars: 137,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "There is an old English lore that two Magpie birds together represent joy and mirth. We like to think that is us in a nutshell. You will see that happiness when you see our team working and creating together, having fun curating the perfect gifts and handcrafting many of our exclusive in-house made products varying from our slowly cured cold process soaps, to lotions and scrubs and more made with natural ingredients nourishing for your body and soul.\n\nPatty boasts 11 years of corporate retail experience in various positions such as Event Coordinator for Recollections Paper Crafting Studios (owned by Michael's Arts and Craft Stores, Inc.), and store manager for corporately owned Hallmark Stores in the Phoenix area before opening her own business as a specialty paint boutique – Green Table Mercantile where her passion for teaching and creating flourished. Patty has been published in nationally distributed print magazines as well as a craft contributor for blogs. While her shop was open, she was featured locally in the Arizona Republic, East Valley Tribune, and numerous repeat television features on Sonoran Living, Your life A to Z, and Phoenix area news channels 3, 5, 10, 12 and 15 over the 6 years of her business. With a new season of life, her family moved to Prescott in 2018 and set down roots and bring her talents together with the Prescott area community.",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:02.894Z",
    importedBy: "entity-db-cli",
  },
};
